export default "__VITE_ASSET__BgWwasnT__"